import { render, staticRenderFns } from "./ymqc_edit.vue?vue&type=template&id=155f85e2&scoped=true&"
import script from "./ymqc_edit.vue?vue&type=script&lang=js&"
export * from "./ymqc_edit.vue?vue&type=script&lang=js&"
import style0 from "./ymqc_edit.vue?vue&type=style&index=0&id=155f85e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155f85e2",
  null
  
)

export default component.exports